export default function formatObjectWithKeysAsArray(object) {
  return Object.keys(object).map(key => {
    return object[key];
  });
}
